var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settleInLayout"},[_c('el-header',{staticClass:"header",attrs:{"height":"80px"}},[_c('div',{staticClass:"header-inner w w1200"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"alt":"腾信电商"},on:{"click":function($event){return _vm.$router.push('/')}}})])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e40598d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/merchantSettled/settleInLayout.vue
// module id = null
// module chunks = 